import { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { GameTypeEnum } from "../../../enumeration/GameTypeEnum";
import { CheckIsNull } from "../../../utils/CommonHelper";
import { GameListing } from "../../common/components/GameListing";
import * as actions from "../redux/FishingAction";

export const FishingListing = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [category, setCategory] = useState("all");
  const { companyCode } = useParams();
  const navigate = useNavigate();
  const [companyName, setCompanyName] = useState();
  const location = useLocation();
  const [companyOffset, setCompanyOffset] = useState(
    location.state ? parseInt(location.state.companyOffset) : 0
  );
  const isInitial = useRef(true);

  const fishingState = useSelector(({ fishing }) => fishing, shallowEqual);

  const fetchGameList = () => {
    const params = {
      action: "mbfishinggamelistV2",
      companycode: companyCode,
      category,
    };

    dispatch(actions.getFishingGameList(params)).then(() => {
      if (location.state && isInitial.current) {
        if (document.querySelector(".outlet-wrapper"))
          document.querySelector(".outlet-wrapper").scrollTo({
            top: parseInt(location.state.scrollPosition),
            behavior: "smooth",
          });
      }
      isInitial.current = false;
    });
  };

  useEffect(() => {
    fetchGameList();
  }, [companyCode, category]);

  const handlePlayGame = (gameCode, searchName) => {
    sessionStorage.setItem("lastSelectGame", gameCode);
    const currentScrollPosition = document.querySelector(".outlet-wrapper")
      ? document.querySelector(".outlet-wrapper").scrollTop
      : window.scrollY || document.documentElement.scrollTop;
    navigate(
      `/gamePlay/${companyCode}/${gameCode}/${companyOffset}/${currentScrollPosition}/${
        GameTypeEnum.FISHING
      }${CheckIsNull(searchName) ? "" : `/${searchName}`}`
    );
  };

  useEffect(() => {
    if (fishingState.fishingGameList) {
      const foundCompany = fishingState.fishingGameList.companyGameLists.find(
        (company) => company.companycode === companyCode
      );

      if (foundCompany) {
        setCompanyName(foundCompany.companyname);
      }
    }
  }, [fishingState.fishingGameList, companyCode]);

  const clearPromotion = () => {
    dispatch(actions.clearPromotion());
  };

  return (
    <>
      <GameListing
        gameCompanyList={fishingState.fishingGameList?.companyGameLists}
        gameCategoryList={fishingState.fishingGameList?.fishingGameCategories}
        gameList={fishingState.fishingGameList?.fishingGameLists}
        promotionLists={fishingState.fishingGameList?.promotionLists}
        activepromotionid={fishingState.fishingGameList?.activepromotionid}
        setCategory={setCategory}
        category={category}
        companyCode={companyCode}
        handlePlayGame={handlePlayGame}
        setCompanyOffset={setCompanyOffset}
        companyOffset={companyOffset}
        initialSearchName={location.state ? location.state.searchName : ""}
        companyName={companyName}
        gameType={"fishing"}
        clearPromotion={clearPromotion}
      />
    </>
  );
};
